// Plain, import-free page metadata. Consumed by the React app AND by
// scripts/prerender-seo.js at build time, so the static HTML for every route
// carries its own unique title and meta description.

export const SITE_URL = "https://dentalleadslab.com";
export const SITE_NAME = "Dental Leads Lab";

export const LANDING_TITLE =
  "Dental Leads Lab — Dental Marketing Agency For Predictable New Patients";
export const LANDING_DESCRIPTION =
  "Dental Leads Lab builds the undeniable marketing system for dentists: Google Ads, local SEO, high-converting websites and reputation systems that fill chairs. Book a free strategy call.";
export const LANDING_KEYWORDS =
  "dental marketing agency, dental marketing, marketing for dentists, dental leads, new patient acquisition, dental google ads, dental seo, Dental Leads Lab";

export const BLOG_TITLE =
  "Dental Marketing Blog — Growth Playbooks For Practice Owners | Dental Leads Lab";
export const BLOG_DESCRIPTION =
  "Practical dental marketing guides for practice owners: new patient acquisition, Google Ads, local SEO, website conversion and the numbers that prove your marketing works.";
export const BLOG_KEYWORDS =
  "dental marketing blog, dental practice growth, dental seo, dental google ads, new patient acquisition";

export const LOGIN_TITLE = "Client Sign In | Dental Leads Lab";
export const LOGIN_DESCRIPTION =
  "Sign in to the Dental Leads Lab dashboard to review your new patient leads, booked strategy calls and campaign performance.";

export const ADMIN_TITLE = "Leads Dashboard | Dental Leads Lab";
export const ADMIN_DESCRIPTION =
  "Private Dental Leads Lab dashboard for managing new patient enquiries, strategy call bookings and lead status.";
